// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const TableColumnsOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 512 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M448 32H64A64 64 0 000 96v320a64 64 0 0064 64h384a64 64 0 0064-64V96a64 64 0 00-64-64zM240 448H64c-17.65 0-32-14.36-32-32V192h208v256zm240-32c0 17.64-14.36 32-32 32H272V192h208v224zm0-256H32V96c0-17.64 14.35-32 32-32h384c17.64 0 32 14.36 32 32v64z"}}]},"name":"table-columns","theme":"outlined"};

const TableColumnsOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={TableColumnsOutlinedSvg} />;
  TableColumnsOutlined.displayName = 'TableColumnsOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(TableColumnsOutlined);
